import { toISODate } from "../../utils/date";

export const evaluationDefaults = {
    // Referências Arquiteturais Obrigatórias
    idMember: "",
    memberName: "",
    memberPhone: "",
    memberEmail: "",
    idEmployee: "", // Avaliador
    idActivity: "", // A Modalidade/Atividade sendo avaliada
    idLevel: "", // Nível ALVO do aluno (Para qual faixa/nível ele prestou teste)
    
    // Dados Desnormalizados (Evitam joins caros na UI)
    activityName: "",
    levelName: "",
    employeeName: "",

    // Contexto
    date: toISODate(new Date()), 
    observations: "", // Notas livres da avaliação
    
    // Lista de Notas (Vetor denormalizado das estrelas de cada tópico)
    // Exemplo de estrutura que entrará aqui: 
    // [{ idObjective: "...", idTopic: "...", score: 4, isFundamental: true }]
    grades: [],

    // Consolidação de Notas
    totalScore: 0, 
    averageScore: 0,
    
    // Opcional para Eventos de Graduação
    idEvent: "", // Caso faça parte do "Seminário de Verão", por exemplo
    eventName: "", 
    
    // Status Final da Avaliação
    // "PASSED" (Aprovou de Faixa/Nível) | "FAILED" (Não passou, continua no atual) | "IN_PROGRESS"
    status: "IN_PROGRESS" 
};
